import { Box, Toolbar } from "@mui/material";
import { IoMdClose } from "react-icons/io";
import { useSelector } from "react-redux";
import earningImg from "../../../assets/profile/Navigations & Menu.svg";
import userIdImg from "../../../assets/profile/Shared document icons.svg";
import AutomaticImg from "../../../assets/profile/Status.svg";
import responsibleImg from "../../../assets/profile/auction.svg";
import internetImg from "../../../assets/profile/online-banking.svg";
import visaLog from "../../../assets/profile/visaero_logo 1.svg";
import style from "./eVisa_visaLancer.module.css";

const Data = [
  {
    name: "Automatic payment every month",
    img: AutomaticImg,
  },
  {
    name: "Your VisaLancer ID is unique to you and not transferable",
    img: userIdImg,
  },
  {
    name: "Track your transactions and earnings",
    img: earningImg,
  },
  {
    name: "T3 Visas reserves the right to continue, amend, update or terminate the program",
    img: "https://s3.ap-southeast-1.amazonaws.com/visaero.assets/logo/t3_visas_logo.png", // visaLog,
  },
  {
    name: "VisaLancer is responsible for complying with any applicable regulations and laws",
    img: responsibleImg,
  },
  {
    name: "VisaLancer for T3 Visas.",
    img: internetImg,
  },
];

export default function EVisa_visaLancer({ close }) {
  // const userDetails = JSON.parse(localStorage.getItem("userInfo"))
  const userDetails = useSelector((state) => state.userProfile?.result?.data);
  return (
    <Box className={style.container}>
      <Toolbar
        sx={{
          backgroundColor: "#f07821",
          display: "flex",
          justifyContent: "space-between",
          position: "sticky",
          top: "0px",
          zIndex: 999
        }}
      >
        <h4 style={{ fontSize: "1rem", color: "white", fontWeight: "500" }}>
          My VisaLancer Benefits
        </h4>
        <IoMdClose
          style={{ fontSize: "1.5rem", color: "white", fontWeight: "600" }}
          onClick={() => close(false)}
        />
      </Toolbar>

      <Box sx={{ margin: "1rem" }}>
        <Box>
          <h4 className={style.header}>Welcome {userDetails?.first_name},</h4>
          <p className={style.desc}>
            Check out the highlights of VisaLancer
          </p>
        </Box>

        <Box className={style.items_container}>
          <Box className={style.item_box}>
            <Box className={style.item_box_imageSection}>
              <h4
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "500",
                  position: "relative",
                  color: "black",
                  width: "30%",
                }}
              >
                1
                <span style={{ fontSize: "1rem", position: "absolute" }}>
                  $
                </span>
              </h4>
            </Box>
            <h4>Minimum transaction size is 1</h4>
          </Box>
          {Data?.map((item) => {
            const { name, img } = item;
            return (
              <Box className={style.item_box}>
                <Box className={style.item_box_imageSection}>
                  <img src={img} alt={`icons ${name}`} />
                </Box>
                <h4>{name}</h4>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
}
